import api from './api';
// 首页联盟简介与联盟章程
export function homeCommonData(params) {
  /**
   * 1、banner
   * 2、联盟章程(短介绍)
   * 3、友情链接
   * 4、政府支持
   * 5、联系我们
   * 6、URL二维码
   * 7、联盟简介(长介绍)
   * 8、联盟章程(长介绍)
   */
  return api.post('/common/listcom', params, true, false).then(res => res);
}

// 首页联盟新闻
export function homeBriefNews(params) {
  return api.post('/news/getlistbycount', params, true, false).then(res => res);
}

// 首页联盟专家委员会成员
export function homeExpert(params) {
  return api.post('/expert/getHome', params, true, false).then(res => res);
}

// 首页产品展示
export function homeProduct(params) {
  return api.post('/product/getHome', params, true, false).then(res => res);
}

// 首页专家论坛 10
export function homeOpinion(params) {
  return api.post('/news/getlistbytype', params, true, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/frontHome.js